import { combineReducers } from 'redux';
import authReducer from './authReducer';
// import towerReducer from './towerReducer';
// import gameReducer from './gameReducer';

export default combineReducers({
  auth: authReducer,
  // tower: towerReducer,
  // game: gameReducer,
});
